import type { NewsItem } from "@/types";

export const newsList: NewsItem[] = [
  {
    id: "summer-2024-lineup",
    title: "2024夏季新番阵容公布：超过 40 部动画定档",
    summary:
      "本季新番涵盖热血、治愈、科幻等多元题材，多部人气续作与原创作品同台竞技，被观众称为近年来竞争最激烈的一季。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20multiple%20anime%20posters%20arranged%20in%20a%20vibrant%20summer%20lineup%20collage%2C%20bright%20celebratory%20colors%2C%20energetic%20composition%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-01&orientation=landscape",
    category: "新番",
    publishedAt: "2024-06-20",
    views: 18240,
    content: [
      "随着春季档陆续收官，2024 夏季新番的完整阵容终于正式公布。据统计，本季定档作品超过 40 部，题材覆盖热血战斗、治愈日常、科幻冒险、青春恋爱等多个方向，被不少观众评价为「近年来最有看头的一季」。",
      "在续作方面，多部人气作品确认回归。其中既有口碑积累多年的长篇系列，也有去年话题度极高的黑马之作。制作公司普遍提高了作画预算，部分作品更宣布采用全流程数字作画，画面表现值得期待。",
      "原创动画同样是本季的一大亮点。多部没有原作基础的全新企划选择在夏季档登场，涵盖悬疑、奇幻等相对小众的方向。业内人士认为，原创作品的表现将直接影响观众对本季整体的评价。",
      "此外，本季的播出形式也更加多样。除了传统的电视放送，多部作品选择在网络平台同步或提前播出。观众可以根据自己的习惯选择合适的追番方式，进一步降低了观看门槛。",
    ],
  },
  {
    id: "sword-and-sky-interview",
    title: "专访《剑与苍穹》制作组：如何打造一场史诗冒险",
    summary:
      "从世界观设定到战斗分镜，制作组分享了这部高人气作品背后的创作理念与制作难点。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20an%20animation%20studio%20desk%20with%20character%20sketches%20and%20storyboards%2C%20creative%20work%20process%20atmosphere%2C%20warm%20light%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-02&orientation=landscape",
    category: "专题",
    publishedAt: "2024-06-18",
    views: 14320,
    content: [
      "《剑与苍穹》自开播以来热度持续攀升，其宏大的世界观与流畅的战斗演出收获了大量好评。本次我们专程专访了制作组，聊了聊这部作品幕后的故事。",
      "谈到最初的世界观设定，总导演表示，团队希望塑造一个「有重量感」的幻想世界。为此，美术团队花费数月时间绘制了完整的大陆地图与各国文化设定，甚至连武器锻造方式都有详细考据。",
      "战斗分镜是本作最受称赞的部分。作画监督透露，为了呈现剑技的冲击力，团队大量参考了真实剑术动作，并通过逐帧调整来强化角色的发力与惯性，让每一次挥剑都极具张力。",
      "对于后续剧情，制作组卖了个关子，只说「真正的冒险才刚刚开始」。他们希望观众能继续陪伴主角走完这段旅程。",
    ],
  },
  {
    id: "anime-market-report",
    title: "行业观察：动漫产业规模再创新高，海外市场成增长引擎",
    summary:
      "最新行业报告显示，动漫相关产业规模连续多年增长，流媒体与海外发行成为主要驱动力。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20rising%20growth%20charts%20and%20a%20globe%20with%20streaming%20icons%2C%20business%20analysis%20atmosphere%2C%20modern%20clean%20composition%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-03&orientation=landscape",
    category: "热点",
    publishedAt: "2024-06-16",
    views: 9870,
    content: [
      "近日发布的行业报告显示，动漫相关产业规模连续多年保持增长态势，整体产值再度创下新高。流媒体平台的全球化布局与海外发行渠道的拓宽，成为拉动增长的主要动力。",
      "报告指出，海外市场已成为产业增长的重要引擎。越来越多的作品选择在全球范围同步上线，多语言配音与字幕的普及，显著提升了海外观众的观看体验。",
      "与此同时，衍生品、线下活动与授权合作等周边业务也保持活跃。业内人士分析，围绕 IP 展开的多维度运营，正在让动漫产业的价值链条变得更加完整。",
      "不过，报告也提醒行业关注制作人才的培养与工作环境的改善，认为只有保证创作环节的健康，产业才能实现可持续的增长。",
    ],
  },
  {
    id: "star-voyager-episode-9",
    title: "《星海旅人》第 9 集引发热议，剧情走向成焦点",
    summary:
      "最新一集的剧情反转出乎许多观众意料，相关话题迅速登上讨论榜前列。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20lone%20starship%20traveling%20through%20a%20glowing%20nebula%20in%20deep%20space%2C%20dramatic%20cosmic%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-04&orientation=landscape",
    category: "热点",
    publishedAt: "2024-06-15",
    views: 11250,
    content: [
      "《星海旅人》本周播出的第 9 集在观众中引发了强烈讨论。这一集不仅揭开了一直以来悬而未决的谜团，还抛出了新的疑问，让不少观众直呼「完全没猜到」。",
      "剧情中主角对自身身份的重新认识，成为本集最大的情感爆点。配合恰到好处的演出与配乐，短短几分钟的段落被很多观众评为「本季最佳片段之一」。",
      "讨论热度迅速蔓延到各大社交平台，相关话题一度冲上话题榜前列。观众们纷纷展开分析，试图从早前的伏笔中寻找线索，猜测后续的发展方向。",
      "制作组随后在社交账号上发布了一张意味深长的概念图，被粉丝们解读为对后续剧情的暗示，进一步推高了期待值。",
    ],
  },
  {
    id: "healing-anime-trend",
    title: "治愈系动画为何持续走红？观众需要的是情绪出口",
    summary:
      "在快节奏的生活中，温暖细腻的治愈系作品正成为越来越多观众的选择。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20cozy%20quiet%20cafe%20corner%20with%20a%20warm%20cup%20and%20soft%20plants%2C%20calm%20gentle%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-05&orientation=landscape",
    category: "专题",
    publishedAt: "2024-06-12",
    views: 8640,
    content: [
      "近年来，治愈系动画的关注度持续上升。从温馨的日常小品到细腻的情感故事，这类作品凭借温暖的气质，吸引了大量观众。",
      "有分析认为，治愈系作品的走红与现实生活节奏的加快密切相关。当人们面对压力与疲惫时，一段柔和、不刻意制造冲突的故事，往往能提供难得的情绪舒缓。",
      "与强调悬念和冲突的作品不同，治愈系动画更注重氛围的营造与细节的积累。一碗热汤、一次散步、一句简单的问候，都能成为打动观众的关键。",
      "创作者们也意识到这一点。越来越多的作品开始有意识地放慢节奏，把镜头留给那些平凡却动人的瞬间，让观众在观看过程中获得真正的放松。",
    ],
  },
  {
    id: "mecha-era-anniversary",
    title: "《机甲纪元》周年纪念活动开启，主创齐聚回顾",
    summary:
      "为庆祝作品完结一周年，官方推出特别纪念企划，包括回顾特辑与限定周边。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20giant%20mecha%20robot%20silhouette%20against%20a%20celebratory%20sky%20with%20light%20particles%2C%20festive%20epic%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-06&orientation=landscape",
    category: "热点",
    publishedAt: "2024-06-10",
    views: 7320,
    content: [
      "为庆祝《机甲纪元》完结一周年，官方正式宣布开启特别纪念企划。活动内容包括回顾特辑、主创对谈以及一系列限定周边，令众多老观众倍感惊喜。",
      "在公开的对谈片段中，主创团队回顾了作品从企划到完结的全过程，分享了许多不为人知的幕后故事。几位主要声优也通过视频送上了祝福。",
      "官方同时放出了一段高清回顾影像，重现了作品中多个经典场景。许多观众表示，再次看到这些画面时依然会热血沸腾。",
      "据悉，本次纪念企划将持续一个月，后续还会陆续公布更多内容，感兴趣的观众可以持续关注官方动态。",
    ],
  },
  {
    id: "original-anime-rise",
    title: "原创动画迎来爆发期，多部新作宣布立项",
    summary:
      "不依赖原作的原创动画数量明显增加，创作者获得了更大的表达空间。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20blank%20storyboard%20pages%20coming%20to%20life%20with%20glowing%20sketches%2C%20creative%20inspiration%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-07&orientation=landscape",
    category: "专题",
    publishedAt: "2024-06-08",
    views: 6540,
    content: [
      "近期，多部原创动画相继宣布立项，原创作品在整体内容中的占比明显提升。与改编作品相比，原创动画不受原作框架的限制，创作者能够拥有更大的表达空间。",
      "业内人士认为，平台方对原创内容的投入，是推动这一趋势的重要原因。随着观众审美的多元化，具备独特气质与辨识度的原创作品，正获得越来越多的机会。",
      "当然，原创动画也面临更大的风险。没有原作粉丝基础，作品的口碑几乎完全依赖自身的质量。这对剧本、演出与整体企划提出了更高的要求。",
      "尽管如此，不少创作者仍对原创方向充满热情。他们认为，正是这种不确定性，让原创动画充满了可能性与惊喜。",
    ],
  },
  {
    id: "voice-actor-awards",
    title: "年度声优大赏揭晓，多位实力派演员获奖",
    summary:
      "本届声优大赏表彰了过去一年中表现突出的配音演员，颁奖现场星光熠熠。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20microphone%20on%20a%20stage%20under%20warm%20spotlight%20with%20glowing%20particles%2C%20award%20ceremony%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-08&orientation=landscape",
    category: "热点",
    publishedAt: "2024-06-05",
    views: 5980,
    content: [
      "一年一度的声优大赏近日揭晓，多位实力派配音演员凭借过去一年的出色表现获奖。颁奖现场气氛热烈，众多业内人士到场祝贺。",
      "本届评选涵盖了最佳主演、最佳配角、最佳新人等多个奖项。评审团表示，本年度的竞争格外激烈，许多提名者之间的差距非常微小。",
      "获奖者在发表感言时，纷纷感谢了合作团队与一直支持自己的观众。有演员动情地说，声音是连接角色与观众的桥梁，能参与其中感到非常幸福。",
      "主办方透露，未来将继续完善评选机制，并计划举办更多面向观众的交流活动，让配音艺术被更多人了解与喜爱。",
    ],
  },
  {
    id: "anime-tourism",
    title: "动漫圣地巡礼升温，取景地成为旅行新热点",
    summary:
      "越来越多的观众选择前往动画取景地旅行，带动了当地文旅产业的发展。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20scenic%20seaside%20town%20with%20a%20train%20station%20and%20hills%2C%20travel%20postcard%20atmosphere%2C%20warm%20daylight%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-09&orientation=landscape",
    category: "专题",
    publishedAt: "2024-06-02",
    views: 7210,
    content: [
      "随着越来越多动画作品以真实地点为取景参考，「圣地巡礼」逐渐成为一股旅行热潮。观众们循着作品的足迹，前往一处场景对应的现实地点打卡。",
      "这些取景地往往独具魅力。海边小镇、山间车站、古老的街道，在动画的镜头下被赋予了特殊的情感，吸引着粉丝们前来亲身体验。",
      "对当地而言，这股热潮也带来了实实在在的变化。餐饮、住宿与纪念品等相关行业明显受益，一些地方还专门推出了与作品联动的主题活动。",
      "有观察者指出，如何在开发与保护之间取得平衡，是这些取景地需要长期思考的课题。",
    ],
  },
  {
    id: "summer-festival-guide",
    title: "夏季漫展观展指南：这些展区值得一看",
    summary:
      "年度大型漫展即将开幕，官方公布了展区分布与重点活动安排。",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20anime%20editorial%20illustration%20of%20a%20lively%20convention%20hall%20with%20colorful%20booths%20and%20crowds%2C%20festive%20event%20atmosphere%2C%20cel-shaded%20digital%20art%2C%20clean%20line%20art%2C%20no%20text%2C%20high%20detail&width=800&height=500&seq=news-thumb-10&orientation=landscape",
    category: "新番",
    publishedAt: "2024-05-30",
    views: 8340,
    content: [
      "年度大型漫展即将拉开帷幕，主办方公布了本届的展区分布与重点活动安排。无论你是资深爱好者还是初次参加的新人，都能在这里找到属于自己的乐趣。",
      "本届漫展设置了多个主题展区，涵盖作品展示、周边贩售、舞台演出与互动体验等不同内容。多部热门作品也将设立专属展位，带来限定展示与周边。",
      "展会期间，多场主创见面会与声优活动将轮番登场。由于部分活动需要提前预约，主办方建议观众提前查看日程，做好观展规划。",
      "此外，主办方特别提醒观众注意现场秩序与人流引导，合理安排休息时间，让整场漫展之旅既尽兴又舒适。",
    ],
  },
];